export class CannotUpdateClaimError extends Error {
  constructor() {
    super('The claim status of this order has already been changed. Please refresh this page.')
    Object.setPrototypeOf(this, CannotUpdateClaimError.prototype)
  }
}
